import { BackupSymlinkType } from 'mbs-ui-shared@models/backup-symlink-type.enum';

export class SettingsBackupSymlinksModel {
  enabled: boolean;
  value: BackupSymlinkType;

  constructor() {
    this.enabled = false;
    this.value = BackupSymlinkType.backupSymlinksOnly;
  }
}
